const windowWidth = window.innerWidth
let sidemenu = document.querySelector('.offcanvas--sidemenu')

if (sidemenu) {
  let burger = sidemenu.querySelector('.offcanvas__burger')

  const setSidemenuSizes = () => {
    let topbarHeight = document.querySelector('.topbar').clientHeight
    let menuNavHeight = document.querySelector('.menu__nav').clientHeight
    sidemenu.style.top = `${topbarHeight}px`
    burger.style.height = `${menuNavHeight}px`
  }

  setSidemenuSizes()

  window.addEventListener('resize', function() {
    if (this.innerWidth != windowWidth) {
      setSidemenuSizes()
    }
  })
}
